import * as React from "react";
import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { useOnline } from "duck";
import { CaseStatusEnum } from "requests";
import { SelectionContext } from "../../../../duck";
import {
  Archive,
  Export,
  MakeActive,
  Remove,
  Rename,
  Copy
} from "./components";

const Actions: React.FC = () => {
  const online = useOnline();

  const { selection } = React.useContext(SelectionContext);
  const archiveShown = selection.every(
    mc => mc.status === CaseStatusEnum.Active
  );
  const makeActiveShown = selection.every(
    mc => mc.status === CaseStatusEnum.Archived
  );

  const exportAllowed =
    selection.length === 1 && selection[0].offlineStatus === "normal";

  const isSelectedCaseFromVetspire =
    selection.length === 1 && selection[0].fromVetspire;

  const removeAllowed = online
    ? true
    : selection.every(mc => mc.offlineStatus === "offline");

  const [opened, setOpened] = React.useState(false);

  return (
    <Menu
      isOpen={opened}
      placement="bottom-end"
      closeOnSelect={false}
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      autoSelect={false}
    >
      <MenuButton
        as={Button}
        colorScheme="minor"
        isDisabled={selection.length === 0}
      >
        Actions
      </MenuButton>
      <MenuList>
        {online && exportAllowed && (
          <Export
            isVetspireCase={isSelectedCaseFromVetspire}
            onClose={() => setOpened(false)}
          />
        )}
        {selection.length === 1 && <Rename onClick={() => setOpened(false)} />}
        {archiveShown && (
          <Archive
            onSuccess={() => {
              setOpened(false);
            }}
          />
        )}
        {makeActiveShown && (
          <MakeActive
            onSuccess={() => {
              setOpened(false);
            }}
          />
        )}
        {online && selection.length === 1 && <Copy />}
        {removeAllowed && <Remove />}
      </MenuList>
    </Menu>
  );
};

export default Actions;
